module.exports = __webpack_public_path__ + "img/immediate-annuity-insurance-filled.053a3bf.png";